module.exports = __webpack_public_path__ + "static/media/screenshot(1).84f0bf54.jpg";